import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

export type Checklist = { id: string; name: string };

type ChecklistSelectorProps = {
  checklists: Checklist[];
  value: string | undefined;
  onChange: (id: string) => void;
};

const ChecklistSelector: React.FC<ChecklistSelectorProps> = ({
  checklists,
  value,
  onChange,
}) => {
  const [selectedChecklist, setSelectedChecklist] = React.useState<Checklist | undefined>(undefined);

  React.useEffect(() => {
    var checklist = checklists.find((cl) => cl.id === value);
    if (checklist && checklists.length > 0) {
      setSelectedChecklist(checklist);
      onChange(checklist.id);
    }
  }, [value]);

  return (
    <FormControl fullWidth margin="dense">
    <InputLabel id="assigned-checklist-label">Checklist</InputLabel>
    <Select
      labelId="assigned-checklist-label"
      value={value || ""}
      label="Checklist"
      onChange={(e) => onChange(e.target.value as string)}
    >
      {checklists.map((cl) => (
        <MenuItem key={cl.id} value={cl.id}>
          {cl.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)};

export default ChecklistSelector;